import { httpGet } from "./request/requestApi";
const controllerEndpoint = "els/report/search/overview";
export class GlobalSearchApi {
    static searchOverview(params) {
        const { searchType, keyword, limit = 10 } = params;
        const base = typeof searchType === "string" && searchType.trim().length > 0 ? `${controllerEndpoint}/${encodeURIComponent(searchType)}` : controllerEndpoint;
        const qs = new URLSearchParams({
            limit: String(limit),
            keyword: keyword !== null && keyword !== void 0 ? keyword : "",
        });
        return httpGet(`${base}?${qs.toString()}`, { silent: true });
    }
}
export default GlobalSearchApi;
